import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { SUPPORTED_LANGUAGES } from "./languages";

const supportedLngs = SUPPORTED_LANGUAGES.map((language) => language.code);

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs,
    nonExplicitSupportedLngs: true,
    debug: false,
    detection: {
      order: [
        "cookie",
        "localStorage",
        "navigator",
        "htmlTag",
        "querystring",
        "path",
        "subdomain",
      ],
      caches: ["cookie", "localStorage"],
      lookupQuerystring: "lng",
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    backend: {
      loadPath: "/locales/language_{{lng}}.json",
    },
  });

if (typeof document !== "undefined") {
  document.documentElement.lang = i18next.resolvedLanguage || "en";
}

i18next.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
  }
});

export default i18next;
